import { extractCaseNumber, normalize } from '../presets/intentMatcher';

/**
 * Words that mark a question as being about the account rather than a case: billing, payments,
 * pricing, login. Such a question is never routed to a case's design team.
 */
export const NON_CASE_TOPIC = /\b(bill|bills|billing|invoice|invoices|invoiced|charge|charged|charges|fee|fees|payment|payments|pay|paid|card|credit card|statement|statements|refund|refunds|refunded|receipt|receipts|price|prices|pricing|cost|costs|quote|quotes|subscription|account|login|log in|logged in|password|sign in|username|email address|billing address|practice address|tax|gst|vat|discount|credit)\b/;

/**
 * True when the question is about billing, payment, pricing or the account rather than a case. A
 * message that names a case number is always about that case, whatever else it says.
 */
export function isNonCaseTopic(text: string | null | undefined): boolean {
  const raw = String(text ?? '');
  if (!raw.trim()) return false;
  if (extractCaseNumber(raw)) return false;
  return NON_CASE_TOPIC.test(normalize(raw));
}
